import { createContext } from 'react';

export const defaultAuthContextValue = {
  user: null,
  session: null,
  isAuthenticated: false,
  isLoading: true,
  emailVerified: false,
  signUp: async () => {},
  signIn: async () => {},
  signInWithGoogle: async () => {},
  signOut: async () => {},
  resetPassword: async () => {},
  updatePassword: async () => {},
  refreshSession: async () => {},
  resendVerificationEmail: async () => {},
};

export const AuthContext = createContext(defaultAuthContextValue);

export default AuthContext;
